import type {ReferenceCreationContext} from './ReferenceCreationContext';
import type {ReferencePlaneCalculationSource} from './reference-plane/ReferencePlaneCalculationSource';


/**
 * 基准面历史实体 ID。
 */
export const DATUM_PLANE_HISTORY_ENTITY_ID = 'datum-plane-manager';

/**
 * 基准面历史三维向量。
 */
export type DatumPlaneHistoryVector3 = readonly [number, number, number];

/**
 * 单个基准面历史记录。
 */
export interface DatumPlaneHistoryRecord {
  /** 基准面数值 ID。 */
  planeId: number;
  /** 基准面名称。 */
  name: string;
  /** 基准面创建上下文。 */
  creationContext: ReferenceCreationContext;
  /** 基准面显示原点。 */
  originWorld: DatumPlaneHistoryVector3;
  /** 基准面法向。 */
  normal: DatumPlaneHistoryVector3;
  /** 基准面 X 轴。 */
  xAxis: DatumPlaneHistoryVector3;
  /** 基准面 Y 轴。 */
  yAxis: DatumPlaneHistoryVector3;
  /** 显示宽度。 */
  width: number;
  /** 显示高度。 */
  height: number;
  /** 显示颜色。 */
  color: number;
  /** 是否可见。 */
  visible: boolean;
  /** 不透明度。 */
  opacity: number;
  /** 基准面计算来源。 */
  calculationSource?: ReferencePlaneCalculationSource | null;
  /** 用户手动创建时间戳（毫秒），用于设计树时间线排序。 */
  createdAt?: number;
}

/**
 * 用户手动创建基准面的设计树时间线登记项。
 *
 * 设计说明：
 * 1. 仅记录非默认内置基准面，默认前/上/右视基准面不进入该时间线；
 * 2. 数组顺序与创建登记顺序一致，设计树投影可据此与 Worker 特征按时间合并排序；
 * 3. 该结构只保存 plain data，不持有任何 Three.js 或场景对象引用。
 */
export interface UserCreatedDatumPlaneTimelineEntry {
  /** 基准面数值 ID。 */
  planeId: number;
  /** 创建时间戳（毫秒）。 */
  createdAt: number;
}

/**
 * 基准面管理器历史快照。
 *
 * 设计说明：
 * 1. 快照只保存可序列化主状态，不保存 Three.js 对象；
 * 2. 默认前/上/右基准面由管理器构造阶段固定创建，不进入模型历史；
 * 3. 用户创建的零件态和装配体态基准面都通过该快照恢复。
 */
export interface DatumPlaneHistorySnapshot {
  /** 管理器历史实体 ID。 */
  managerId: string;
  /** 用户创建的基准面记录。 */
  planes: DatumPlaneHistoryRecord[];
}

